import { ClbAccordion } from "@celebration/react/ClbAccordion/ClbAccordion";
import type { AccordionProps } from "@components/contracts/Accordion.types";
import type React from "react";

export const CelebrationAccordion: React.FC<AccordionProps> = ({
  children,
  ...props
}) => (
  <ClbAccordion {...props} accordionStyle="fill">
    {children}
  </ClbAccordion>
);
